/**
 * The organization trial, said above every page to whoever can end it by
 * buying — its owner and administrators — with the one button that does:
 * Buy seats, which opens Billing, where the purchase is made.
 *
 * Not on Billing itself, which says the trial in its own card right above the
 * seats to buy. And gone as soon as a sale is recorded: the words come from
 * `trialNotice`, which reads the subscription the sale writes.
 */
import type React from 'react';
import { color } from '../theme/tokens';
import { PrimaryButton } from './primitives';
import { trialNotice } from '../lib/billing';
import type { Organization } from '../lib/types';

export function TrialBanner({
  organization,
  admin,
  onBuy
}: {
  organization: Organization | null;
  admin: boolean;
  onBuy: () => void;
}): React.JSX.Element | null {
  const notice = trialNotice(organization, admin);
  if (!notice) return null;
  return (
    <div style={{ padding: '16px var(--al-gutter) 0' }}>
      <div
        role="status"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          flexWrap: 'wrap',
          borderLeft: `2px solid ${color.accent}`,
          background: color.noteTealBg,
          padding: '14px 18px',
          borderRadius: '0 10px 10px 0'
        }}
      >
        <div style={{ flex: '1 1 320px', minWidth: 0 }}>
          <div style={{ fontSize: 13.5, fontWeight: 600, color: color.ink }}>{notice.title}</div>
          <div style={{ fontSize: 13.5, color: color.inkBody, marginTop: 4, lineHeight: 1.55 }}>{notice.body}</div>
        </div>
        <PrimaryButton size="sm" onClick={onBuy}>
          Buy seats
        </PrimaryButton>
      </div>
    </div>
  );
}
